import { render, staticRenderFns } from "./CouponHistory.vue?vue&type=template&id=374db4a0&"
import script from "./CouponHistory.vue?vue&type=script&lang=js&"
export * from "./CouponHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports